module.exports = "https://static.wmbcdn.com/uniweb/images/7dc407d90ad2477583068bfa3ee66cf9.svg";